import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { FirestoreService } from '../services/firestore.service'
import { SwiperConfigInterface } from 'ngx-swiper-wrapper'
import { Location } from '@angular/common'

@Component({
  selector: 'app-list-menu',
  templateUrl: './list-menu.component.html',
  styleUrls: ['./list-menu.component.scss']
})
export class ListMenuComponent implements OnInit {

  public swiperConfig: SwiperConfigInterface
  screenW = window.innerWidth
  lang
  collection
  title
  data = []
  commonData = []
  titles = {
    es: {
      red: 'Tinto',
      white: 'Blanco',
      rose: 'Rosado'
    },
    en: {
      red: 'Red',
      white: 'Blanc',
      rose: 'Rosè'
    },
    de: {
      red: 'Red',
      white: 'Blanc',
      rose: 'Rosè'
    }
  }

  constructor(public activatedRoute: ActivatedRoute, private fs: FirestoreService, public router: Router, public location: Location) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.data = []
        this.commonData = []
        this.title = this.activatedRoute.snapshot.paramMap.get('title')
        this.lang = localStorage.getItem('lang')
        this.collection = this.activatedRoute.snapshot.paramMap.get('collection')
        if (this.collection !== 'wines' && this.collection) {
          this.fs.getData(this.collection, this.lang).valueChanges().subscribe(data => {
            this.data = data.filter((e: any) => e.published === 'true' || e.published === true)
            this.data = this.data.map((e: any) => {
              return {
                ...e,
                price: parseFloat(e.price).toFixed(2)
              }
            })
          })
        } else if (this.collection) {
          this.data.push({ name: this.titles[this.lang].red, id: 'red' })
          this.data.push({ name: this.titles[this.lang].white, id: 'white' })
          this.data.push({ name: this.titles[this.lang].rose, id: 'rose' })
        } else if (this.activatedRoute.snapshot.paramMap.get('wines')) {
          this.fs.getDataFiltered('wines', this.lang, this.activatedRoute.snapshot.paramMap.get('id')).valueChanges().subscribe(data => {
            this.data = data.filter((e: any) => e.published === 'true' || e.published === true)
          })
        }
      }
    })
  }

  goBack() {
    this.location.back()
  }

  ngOnInit() {
    this.swiperConfig = {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 3,
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
      autoplay: false,
      // slidesPerView: 2.5,
      spaceBetween: 15,
      loop: true,
      pagination: false,
      /*
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
      */

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    }
  }

}
